import { Currency } from '@/core/currency/interfaces';

const AED: Currency = {
    name: 'United Arab Emirates Dirham',
    demonym: 'UAE',
    majorSingle: 'Dirham',
    majorPlural: 'Dirhams',
    codeNumeric: '784',
    symbol: 'د.إ.',
    symbolNative: 'د.إ.',
    minorSingle: 'Fils',
    minorPlural: 'Fils',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'AED',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default AED;
